import { AdviesBoxFormik, LabeledSelectInput } from "adviesbox-shared";
import { LabelValuePairs } from "adviesbox-shared/utils/types";
import { FormikProps, useFormikContext } from "formik";
import React, { ReactElement } from "react";
import Modal from "../../shared/components/modal/Modal";
import { AanvraagState, productSchema, ProductType } from "../infra/aanvraag-schema";
import { AanvraagType } from "../aanvraag-product/aanvraag-product";

export type AanvraagNaarProductProps = {
  product: ProductType;
  closeModal?: () => void;
  onSave?: (data: ProductType) => void;
};

const AanvraagNaarProductModal = ({ product, closeModal, onSave }: AanvraagNaarProductProps): ReactElement => {
  const formik = useFormikContext<AanvraagState>();

  const methodeIndienenOptions: LabelValuePairs = [
    {
      label: `Rechtstreeks naar ${product.partijnaam}`,
      value: `${AanvraagType.Serviceprovider}**${product.partijnaam}****${product.hdnNummer}`
    }
  ];

  formik.values.serviceprovider.forEach(serviceprovider => {
    methodeIndienenOptions.push({
      label: `Via ${serviceprovider.naam}`,
      value: `${AanvraagType.Serviceprovider}**${serviceprovider.naam}**${serviceprovider.serviceproviderId}**${serviceprovider.hdnNummer}`
    });
  });

  formik.values.softwareKoppelingen.forEach(softwareKoppeling => {
    methodeIndienenOptions.push({
      label: `Via ${softwareKoppeling.naam}`,
      value: `${AanvraagType.SoftwareKoppeling}**${softwareKoppeling.naam}****${softwareKoppeling.softwareKoppelingId}`
    });
  });

  return (
    <AdviesBoxFormik<ProductType>
      initialValues={product}
      validationSchema={productSchema}
      closeModal={closeModal}
      onSave={onSave}
      data-testid="aanvraag-naar-product-modal"
      render={({ submitForm, dirty }: FormikProps<ProductType>): ReactElement => {
        return (
          <>
            <Modal
              title="Aanvraag naar"
              saveButtonTekst={"Bevestigen"}
              onSubmitClick={submitForm}
              onCancelClick={closeModal}
              body={
                <>
                  <LabeledSelectInput
                    caption="Methode indienen"
                    name="methodeIndienen"
                    options={methodeIndienenOptions}
                  />
                </>
              }
              isFormDirty={dirty}
            />
          </>
        );
      }}
    />
  );
};

AanvraagNaarProductModal.displayName = "AanvraagNaarProductModal";

export default AanvraagNaarProductModal;
